export default {
    getAgeAndHeight: state => state.ageAndHeight,
    getDistance: state => state.distance,
    getDesireToHaveChildren: state => state.desireToHaveChildren,
    getEducationAndIncome: state => state.educationAndIncome,
    getSmokingAndDrinkingHabits: state => state.smokingAndDrinkingHabits,
    getEthnicityAndReligion: state => state.ethnicityAndReligion,
    matchCriteria: state => state.matchCriteria,
};